import {I18nKeys} from '@multipass-i18n';
import {EmptyState, Notice, Panel} from '@multipass-ui-components';
import {syncModelWithSelectorOptions, useSyncModelWithSelector} from 'esp-js-react';
import {GraduationCap, Smartphone} from 'lucide-react';
import * as React from 'react';

import {SESSION_STORE_ID, SessionStoreModel, useT} from '../../logic';

export const HomePage: React.FunctionComponent = () => {
    const t = useT();
    const displayName = useSyncModelWithSelector<SessionStoreModel, string>(
        m => m.displayName ?? '',
        syncModelWithSelectorOptions<string>().setStoreId(SESSION_STORE_ID)
    );
    return (
        <section className="px-5 pb-16 pt-12">
            <div className="mx-auto max-w-[67.5rem]">
                <div className="mb-8">
                    <h1 className="mb-1 text-headline">{t(I18nKeys.home.welcome, {name: displayName})}</h1>
                    <p className="text-body text-text-secondary">{t(I18nKeys.home.subtitle)}</p>
                </div>
                <Notice className="mb-8">
                    <span className="font-semibold text-text-primary">{t(I18nKeys.home.webSoonTitle)}</span>{' '}
                    {t(I18nKeys.home.webSoonBody, {appName: t(I18nKeys.common.appName)})}
                </Notice>
                <Panel icon={GraduationCap} title={t(I18nKeys.home.courseTitle)} comingSoon comingSoonLabel={t(I18nKeys.common.comingSoon)}>
                    <EmptyState icon={Smartphone}>
                        {t(I18nKeys.home.courseEmpty)}
                    </EmptyState>
                </Panel>
            </div>
        </section>
    );
};
